import styled from 'styled-components';
import { Color } from '../../../../common/view/color/color';

const Container = styled.div.withConfig({
  componentId: 'today_container',
  displayName: 'Today.Container',
})`
  height: 100%;
  width: 100%;
`;

const HeaderText = styled.div.withConfig({
  componentId: 'today_header_text',
  displayName: 'Today.HeaderText',
})`
  font-size: 24px;
  font-weight: 600;

  color: ${Color.white4};
`;

export const TodayStyle = {
  Container,
  HeaderText,
};
